// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".button{display:flex;justify-content:center;align-items:center;border-radius:6px;padding:10px 10px 11px 10px;background-color:#80ce1b;color:#061f35;font-family:Roboto Condensed,sans-serif;font-weight:700;font-size:15px;line-height:150%;letter-spacing:.11em;text-transform:uppercase;cursor:pointer}.button:hover{background-color:rgba(128,206,27,.9)}a.button{text-decoration:none}", ""]);
// Exports
module.exports = exports;
